export * from './_entity/editable-test/index.js';
export * from './_entity/app-config/index.js';
//# sourceMappingURL=_entity.js.map